<app-navbar></app-navbar>
<div class="container mt-5">
    <h3><img src="../../../assets/img/registro.png" width="50" alt=""> Registro Usuario: <b>{{usuario}}</b></h3>
    <hr>
    <div *ngIf="distribuidor" class="col-12">
        <form [formGroup]="newUserForm" (ngSubmit)="addNewUser(newUserForm.value)" autocomplete="off">
            <div class="row d-none d-lg-block d-xl-block">
                <div class="col-6">
                    <div class="form-group">
                        <label>Correo Electrónico:</label>
                        <input type="email" class="form-control" formControlName="email" [class.is-invalid]="emailNoValido">
                        <small *ngIf="emailNoValido" class="text-danger">Debe ingresar un correo válido</small>
                    </div>
                    <div class="form-group">
                        <label>Contraseña:</label>
                        <input type="password" class="form-control" formControlName="contrasena" [class.is-invalid]="contrasenaNoValido">
                        <small *ngIf="contrasenaNoValido" class="text-danger">contraseña de mínimo 8 caracteres</small>
                    </div>
                    <div class="form-group">
                        <label>Seleccione imagen o PDF con su RUT:</label>
                        <input type="file" class="form-control" class="form-control" formControlName="rut" (change)="handleImage($event)">
                    </div>
                    <div class="form-group">
                        <label>Dirección de entrega:</label>
                        <input type="text" class="form-control" class="form-control" formControlName="direccion" [class.is-invalid]="direccionNoValido">
                        <small *ngIf="direccionNoValido" class="text-danger">Debe ingresar la dirección</small>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label>Nombre Completo / Razón Social</label>
                        <input type="text" class="form-control" class="form-control" formControlName="nombre" [class.is-invalid]="nombreNoValido">
                        <small *ngIf="nombreNoValido" class="text-danger">Debe ingresar su nombre completo</small>
                    </div>
                    <div class="form-group">
                        <label>Número Telefónico:</label>
                        <input type="number" class="form-control" class="form-control" formControlName="telefono" [class.is-invalid]="telefonoNoValido">
                        <small *ngIf="telefonoNoValido" class="text-danger">Debe ingresar su número de teléfono</small>
                    </div>
                    <div class="form-group">
                        <label>Número de Cédula/Nit:</label>
                        <input type="number" class="form-control" class="form-control" formControlName="cedula" [class.is-invalid]="cedulaNoValido">
                        <small *ngIf="cedulaNoValido" class="text-danger">Debe ingresar su número de cédula correctamente</small>
                    </div>
                    <br>
                    <button class="btnLgn">Enviar Datos</button>
                    <br>
                </div>
            </div>
            <div class="d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
                <div class="col-12">
                    <div class="form-group">
                        <label>Correo Electrónico:</label>
                        <input type="email" class="form-control" formControlName="email" [class.is-invalid]="emailNoValido">
                        <small *ngIf="emailNoValido" class="text-danger">Debe ingresar un correo válido</small>
                    </div>
                    <div class="form-group">
                        <label>Contraseña:</label>
                        <input type="password" class="form-control" formControlName="contrasena" [class.is-invalid]="contrasenaNoValido">
                        <small *ngIf="contrasenaNoValido" class="text-danger">contraseña de mínimo 8 caracteres</small>
                    </div>
                    <div class="form-group">
                        <label>Seleccione imagen o PDF con su RUT:</label>
                        <input type="file" class="form-control" class="form-control" formControlName="rut" (change)="handleImage($event)">
                    </div>
                    <div class="form-group">
                        <label>Dirección de entrega:</label>
                        <input type="text" class="form-control" class="form-control" formControlName="direccion" [class.is-invalid]="direccionNoValido">
                        <small *ngIf="direccionNoValido" class="text-danger">Debe ingresar la dirección</small>
                    </div>
                    <div class="form-group">
                        <label>Nombre Completo / Razón Social</label>
                        <input type="text" class="form-control" class="form-control" formControlName="nombre" [class.is-invalid]="nombreNoValido">
                        <small *ngIf="nombreNoValido" class="text-danger">Debe ingresar su nombre completo</small>
                    </div>
                    <div class="form-group">
                        <label>Número Telefónico:</label>
                        <input type="number" class="form-control" class="form-control" formControlName="telefono" [class.is-invalid]="telefonoNoValido">
                        <small *ngIf="telefonoNoValido" class="text-danger">Debe ingresar su número de teléfono</small>
                    </div>
                    <div class="form-group">
                        <label>Número de Cédula/Nit:</label>
                        <input type="number" class="form-control" class="form-control" formControlName="cedula" [class.is-invalid]="cedulaNoValido">
                        <small *ngIf="cedulaNoValido" class="text-danger">Debe ingresar su número de cédula correctamente</small>
                    </div>
                    <br>
                    <button class="btnLgn">Enviar Datos</button>
                    <br>
                </div>
            </div>
        </form>
    </div>
    <div *ngIf="comprador" class="col-12">
        <form [formGroup]="newUserFormBuyer" (ngSubmit)="addNewUserBuyer(newUserFormBuyer.value)" autocomplete="off">
            <div class="row d-none d-lg-block d-xl-block">
                <div class="col-6">
                    <div class="form-group">
                        <label>Número de Cédula:</label>
                        <input type="text" class="form-control" formControlName="cedula" [class.is-invalid]="buyerCedulaNoValido">
                        <small *ngIf="buyerCedulaNoValido" class="text-danger">Debe ingresar un número válido</small>
                    </div>
                    <div class="form-group">
                        <label>Correo Electrónico:</label>
                        <input type="email" class="form-control" formControlName="email" [class.is-invalid]="buyerEmailNoValido">
                        <small *ngIf="buyerEmailNoValido" class="text-danger">Debe ingresar un correo válido</small>
                    </div>
                    <div class="form-group">
                        <label>Contraseña:</label>
                        <input type="password" class="form-control" formControlName="contrasena" [class.is-invalid]="buyerContrasenaNoValido">
                        <small *ngIf="buyerContrasenaNoValido" class="text-danger">contraseña de mínimo 8 caracteres</small>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label>Nombre Completo:</label>
                        <input type="email" class="form-control" class="form-control" formControlName="nombre" [class.is-invalid]="buyerNombreNoValido">
                        <small *ngIf="buyerNombreNoValido" class="text-danger">Debe ingresar su nombre completo</small>
                    </div>
                    <div class="form-group">
                        <label>Número Telefónico:</label>
                        <input type="number" class="form-control" class="form-control" formControlName="telefono" [class.is-invalid]="buyerTelefonoNoValido">
                        <small *ngIf="buyerTelefonoNoValido" class="text-danger">Debe ingresar su número de teléfono</small>
                    </div>
                    <div class="form-group">
                        <label>Dirección de entrega:</label>
                        <input type="text" class="form-control" class="form-control" formControlName="direccion" [class.is-invalid]="buyerDireccionNoValido">
                        <small *ngIf="buyerDireccionNoValido" class="text-danger">Debe ingresar la dirección</small>
                    </div>
                    <br>
                    <button class="btnLgn">Enviar Datos</button>
                    <br>
                </div>
            </div>
            <div class="d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
                <div class="col-12">
                    <div class="form-group">
                        <label>Número de Cédula:</label>
                        <input type="text" class="form-control" formControlName="cedula" [class.is-invalid]="buyerCedulaNoValido">
                        <small *ngIf="buyerCedulaNoValido" class="text-danger">Debe ingresar un número válido</small>
                    </div>
                    <div class="form-group">
                        <label>Correo Electrónico:</label>
                        <input type="email" class="form-control" formControlName="email" [class.is-invalid]="buyerEmailNoValido">
                        <small *ngIf="buyerEmailNoValido" class="text-danger">Debe ingresar un correo válido</small>
                    </div>
                    <div class="form-group">
                        <label>Contraseña:</label>
                        <input type="password" class="form-control" formControlName="contrasena" [class.is-invalid]="buyerContrasenaNoValido">
                        <small *ngIf="buyerContrasenaNoValido" class="text-danger">contraseña de mínimo 8 caracteres</small>
                    </div>
                    <div class="form-group">
                        <label>Nombre Completo:</label>
                        <input type="email" class="form-control" class="form-control" formControlName="nombre" [class.is-invalid]="buyerNombreNoValido">
                        <small *ngIf="buyerNombreNoValido" class="text-danger">Debe ingresar su nombre completo</small>
                    </div>
                    <div class="form-group">
                        <label>Número Telefónico:</label>
                        <input type="number" class="form-control" class="form-control" formControlName="telefono" [class.is-invalid]="buyerTelefonoNoValido">
                        <small *ngIf="buyerTelefonoNoValido" class="text-danger">Debe ingresar su número de teléfono</small>
                    </div>
                    <div class="form-group">
                        <label>Dirección de entrega:</label>
                        <input type="text" class="form-control" class="form-control" formControlName="direccion" [class.is-invalid]="buyerDireccionNoValido">
                        <small *ngIf="buyerDireccionNoValido" class="text-danger">Debe ingresar la dirección</small>
                    </div>
                    <br>
                    <button class="btnLgn">Enviar Datos</button>
                    <br>
                </div>
            </div>
        </form>
    </div>
</div>